<template>
	<div class="network_err">
		<img src="../../assets/network.png" alt="">
		<p class="text_theme">网络出现错误~</p>
		<div><button @click="handleButtonClick">请刷新重试</button></div>
	</div>
</template>

<script>
	export default {
		methods: {
			handleButtonClick() {
				this.$emit('onRefresh');
			}
		}
	}
</script>

<style scoped>
	.network_err{ width: 1200px;margin: 0 auto;padding: 50px 0; }
	.network_err img{ display: block;width: 320px;margin: 0 auto; }
	.network_err p{ margin-top: 20px;font-size: 18px;text-align: center;line-height: 30px; }
	.network_err div{ margin-top: 20px;text-align: center; }
	.network_err button{ height: 48px;padding: 0 30px;border-radius: 24px;font-size: 18px; }
</style>
